import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const shouldEnableMocks = () => {
  const mode = (process.env.REACT_APP_API_MODE || '').trim().toLowerCase();
  const useMocks = (process.env.REACT_APP_USE_MOCKS || '').trim().toLowerCase();
  return mode === 'mock' || useMocks === 'true';
};

const prepareRuntime = async () => {
  if (!shouldEnableMocks()) {
    return;
  }

  const { worker } = await import('./mocks/browser');
  await worker.start({
    onUnhandledRequest: 'bypass',
    serviceWorker: {
      url: `${process.env.PUBLIC_URL || ''}/mockServiceWorker.js`
    }
  });
};

const root = ReactDOM.createRoot(document.getElementById('root'));

prepareRuntime().finally(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
